import InfoBlock from 'components/UI/Blocks/InfoBlock'
import Typography from 'components/UI/Typography'
import { useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import tw, { TwStyle } from 'twin.macro'

const DigitalDocSkeleton = ({ twStyle, className }: { twStyle?: TwStyle; className?: string }) => {
  // Tools
  const { t } = useTranslation()

  return (
    <InfoBlock className={className} twStyle={twStyle}>
      <Typography variant='body' weight='bold'>
        {t('flow-digital-doc')}
      </Typography>
      <Typography variant='subbody' text twStyle={tw`text-grey-dark mt-4`}>
        {t('flow-confirm-sms')}
      </Typography>
      <Skeleton tw='h-5 rounded-lg w-1/3 mt-4' />
      <Skeleton tw='h-16 rounded-lg w-12 mt-4' inline />
      <Skeleton tw='h-16 rounded-lg w-12 mt-4 ml-2' inline count={5} />
      <Skeleton tw='h-5 rounded-lg w-3/5 mt-4' />
    </InfoBlock>
  )
}

export default DigitalDocSkeleton
